import { useCallback, useState } from "react";
import { useAuthStore } from "../../auth/auth-store";
import { updateBaseUrl } from "../../client/configure-client";
import { persistServerUrl } from "../../client/server-url";

/**
 * Manages the panel's server URL with persistence and client reconfiguration.
 * @param defaultUrl — The URL restored at startup (persisted or build-time default).
 */
export function useServerUrl(defaultUrl: string) {
  const [serverUrl, setServerUrlState] = useState(defaultUrl);

  const setServerUrl = useCallback(
    async (url: string) => {
      const trimmed = url.replace(/\/+$/, "");
      const resolved = trimmed || defaultUrl;
      setServerUrlState(resolved);
      updateBaseUrl(resolved);
      await persistServerUrl(resolved);
      // Tokens are server-specific — clear auth when switching servers
      useAuthStore.getState().clearAuth();
    },
    [defaultUrl],
  );

  return { serverUrl, setServerUrl };
}
